/**
 * Wide data pages that open with the sidebar collapsed to the 64px rail,
 * whatever the saved preference — their result tables need the width.
 * Internal (locale-independent) paths, matched exactly.
 */
export const RAIL_ROUTES: readonly string[] = [
  '/search',
  '/insolvenzticker',
  '/vergabe',
];

export function isRailRoute(internalPathname: string): boolean {
  return RAIL_ROUTES.includes(internalPathname);
}
